import { MainResidenceDetailsMapper } from "./MainResidenceDetailsMapper";
import { FamiliarSituationDetailsMapper } from "./FamiliarSituationDetailsMapper";
import {
  docIdSide,
  docIdTypes,
} from "../../../components/modules/kyc/shared/config";

export const MinimumUseFormDataOfSetUserDetailsMapper = {
  reverseMap(data) {
    return {
      main_residence_details: MainResidenceDetailsMapper.reverseMap(data),
      familiar_situation_details:
        FamiliarSituationDetailsMapper.reverseMap(data),
      ...(data.documentType === docIdTypes.NIE_UE ||
      data.documentType === docIdTypes.PASSPORT
        ? {
            complement_nie_eu: {
              nationality: data.nationality,
              gender: data.gender,
              passport_image: data[docIdSide.PASSPORT_FRONT].result,
            },
          }
        : {}),
    };
  },
};
